module.exports = __webpack_public_path__ + "img/DE02498.30b6853a.png";